import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';
import Load from 'components/Load';

const AsyncInviteePage = Load(() => import(/* webpackChunkName: "withlocals-invitee" */'./components/InviteePage'), {}, true);

const InvitationRoutes = [
  <Route key="withlocals.invitee" path={`${basePath}/join/:bookingId/`} component={AsyncInviteePage} />
];

export default InvitationRoutes;
